import { useQuery } from "@common/utils/use-query";
import { IAddon } from "@stores/addons/types";

export function useGetAddOns({ enabled } = { enabled: true }) {
  return useQuery<IAddon[]>(
    { url: "/addons" },
    {
      enabled,
      refetchInterval: 1000 * 60 * 60 * 12, // reload every 12 hours
      refetchIntervalInBackground: true,
      refetchOnReconnect: false,
    },
  );
}
